import { useRef } from 'react'
import { Icon } from '~/components/icon'
import { useChipsContext } from '../../chips'
import {
  ChipsContainer,
  ChipsInputIcoChecked,
  ChipsInputVariants,
  RadioButtonVariants,
} from '../../chips.styles'
import type { ChipsProps, ChipsScopedProps } from '../../chips.types'

export const ChipsInput = (props: ChipsScopedProps<ChipsProps>) => {
  const { __scopeChips, id, name, value, children, onChange } = props
  const {
    size = 'sm',
    disabled,
    checked,
    readOnly,
  } = useChipsContext('Chips', __scopeChips)
  const chipsRef = useRef<HTMLInputElement>(null)
  const showIcon = disabled || readOnly

  return (
    <label
      className={ChipsInputVariants({
        checked,
        disabled,
        size,
        readOnly,
      })}
      aria-disabled={disabled}
      style={{ cursor: disabled || readOnly ? 'not-allowed' : 'pointer' }}
    >
      <input
        ref={chipsRef}
        type="checkbox"
        className={RadioButtonVariants()}
        id={id}
        disabled={disabled}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        readOnly={readOnly}
      />
      {children}
      {checked && (
        <span className={ChipsInputIcoChecked({ size })}>
          <Icon
            size={'small'}
            symbol={'rdicon-dismiss'}
            color={
              disabled
                ? 'colorTextNeutralDisabled'
                : 'colorTextDangerAlternative'
            }
          />
        </span>
      )}
    </label>
  )
}
